import _ from 'lodash'
import { frameworkDashboardTypes, frameworkRightTypes } from "../cnr/reducers/FrameworkReducer"
import { rightMenuTriggerTypes, rightMenuTypes } from '../cnr/reducers/RightMenuReducer'
import { appIconTypes } from "../enums/appIconTypes"
import { settingsIconTypes } from '../enums/settingsIconTypes'
import { dataModificationTypes } from '../viewSettings/enums/itemActionTypes'
import { _viewStatusTypes } from 'global/cnr/contexts/useHelpers/useViewItemStatus'

const _useDataModification = true

export const appOptions_right = {
  // dashboard: (handlers, settings) => options_dashboard(handlers, settings),
  // dashboards: (handlers, settings) => options_dashboards(handlers, settings),
  // data: (handlers, settings) => options_data(handlers, settings),
  home: (handlers, settings) => options_page_home(handlers, settings),
  page: (handlers, settings) => options_page(handlers, settings),
  propz: (handlers, settings) => options_propz(handlers, settings),
  subAction: (handlers, settings) => options_subAction(handlers, settings),
  // subActions: (handlers, settings) => options_subActions(handlers, settings),
}

const getOptions = (oc) => ({
  propOverride: {
    text: 'Props Override',
    icon: 'wizard',
    color: 'grey',
    oc: oc,
    dividerBefore: true,
    rmt: rightMenuTypes.propsOverride,
  },
  showLog: {
    text: 'Show Log',
    icon: 'list alternate',
    color: 'grey',
    oc: oc,
    dividerBefore: true,
    rmt: rightMenuTypes.showLog,
  },
  showDataJson: {
    text: 'Show Data',
    icon: 'eye',
    color: 'grey',
    oc: oc,
    dividerBefore: true,
    rmt: rightMenuTypes.showDataJson,
  },
  directLinksOverride: {
    text: 'Props Override',
    icon: 'wizard',
    color: 'grey',
    oc: oc,
    dividerBefore: true,
    rmt: rightMenuTypes.directLinksOverride,
  },
  subAction: {
    text: 'Actions',
    icon: 'wizard',
    color: 'grey',
    oc: oc,
    dividerBefore: true,
    rmt: rightMenuTypes.subActions,
  },
});

const options_subAction = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt } = handlers ?? {}
  const opts = options_subActions(handlers, settings, true)
  if (opts.length > 0) {
    return [{ ...getOptions(hs_cmt).subAction }]
  }
  return []
}

const options_page_home = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { isEvent, _allowDatabase, showRightMenuCaptions, directLinksOverrideOn } = settings ?? {}
  const opts = []


  const rmt = rightMenuTriggerTypes.frameworkRight

  isEvent && opts.push({ text: 'Show Log', icon: 'list alternate', color: 'grey', oc: h_ta, rmt, frt: frameworkRightTypes.showLog, dividerBefore: true })
  isEvent && opts.push({ text: 'Show Data', icon: 'eye', color: 'grey', oc: h_ta, rmt, frt: frameworkRightTypes.showDataJson, dividerBefore: true })

  isEvent && opts.push({ text: 'Props Override', icon: 'unordered list', color: 'grey', oc: hs_cmt, rmt: rightMenuTypes.propsOverride, dividerBefore: true })
  isEvent && opts.push({ text: 'Direct Links Only', icon: 'attach', oc: h_ta, rmt: rightMenuTriggerTypes.directLinksOverride, color: directLinksOverrideOn ? 'green' : 'grey' })
  isEvent && _allowDatabase && opts.push({ text: 'Database', icon: 'database', oc: h_ta, rmt: rightMenuTriggerTypes.openDb, color: 'orange', iconCorner: 'arrow right', iconCornerColor: 'grey', dividerBefore: true })
  opts.push({ text: showRightMenuCaptions ? 'Close Menu' : 'Show Menu', icon: showRightMenuCaptions ? 'arrow right' : 'arrow left', oc: h_ta, rmt: rightMenuTriggerTypes.toggle, color: 'grey', dividerBefore: true })
  return opts
}

const options_page = (handlers, settings) => {

  const { handle_triggerAction: h_ta } = handlers ?? {}
  const { frAllows, isLanding, key_viewItem } = settings ?? {}

  const rmt = rightMenuTriggerTypes.frameworkRight

  const opts = []

  opts.push({ text: 'Settings (Page)', icon: appIconTypes.setting, oc: h_ta, rmt: frameworkRightTypes.settings, color: 'blue' })

  // if (!isLanding) {
  //   const _iconColor = frAllows.isTab ? 'green' : null
  //   opts.push({ text: 'Props (' + _.startCase(key_viewItem) + ')', icon: 'list alternate outline', oc: h_ta, rmt, frt: frameworkRightTypes.props, dividerBefore: true })
  //   opts.push({ text: 'Display (' + _.startCase(key_viewItem) + ')', icon: 'television', oc: h_ta, rmt, frt: frameworkRightTypes.display })
  //   opts.push({ text: 'Filters (' + _.startCase(key_viewItem) + ')', icon: 'filter', oc: h_ta, rmt, frt: frameworkRightTypes.filters, dmt: frameworkRightTypes.filters, color: frAllows.constraints ? 'green' : _iconColor, iconCorner: frAllows.constraints ? 'check' : null, })
  // }

  return opts
}

const options_data = (handlers, settings) => {

  const { handle_triggerAction: h_ta } = handlers ?? {}

  const {
    additionalNavigationItems,
    appUserCollections,
    dataModification,
    dataModifications,
    dataOrigin,
    dmOpts,
    frAllows,
    isClient,
    isLanding,
    itemData,
    view,
  } = settings ?? {}

  const { cacheData } = dataOrigin ?? {}

  const rmt = rightMenuTriggerTypes.frameworkRight

  const { viewItemStatus } = dmOpts ?? {}
  const { viewStatusType } = viewItemStatus ?? {}

  const opts = []

  if (isClient) {
    if (isLanding) {
      if (dataModifications) {
        ammendOpts(opts, dataModifications, h_ta, rmt)
      }
    }
  } else {
    let dmos = [];
    switch (viewStatusType) {
      case _viewStatusTypes.list:
        dmos = dmOpts?.list;
        break;
      case _viewStatusTypes.solo:
        dmos = dmOpts?.solo;
        break;
      case _viewStatusTypes.subList:
        dmos = dmOpts?.subList;
        break;
    }

    if (dmos) {
      ammendOpts(opts, dmos, h_ta, rmt)
    }

    if (dataModification && _useDataModification) {
      if (!isLanding) {
        _.forEach(additionalNavigationItems, (ani, aniKey) => {
          const { opts: optz } = ani ?? {}
          const { type, item } = optz ?? {}
          const _icon = settingsIconTypes[type]
          switch (type) {
            case dataModificationTypes.add:
            case dataModificationTypes.edit:
              opts.unshift({ text: _.startCase(type), icon: _icon, oc: h_ta, rmt, frt: frameworkRightTypes.dataModification, dmt: type, frv: item, dividerBefore: true })
              break;
            case dataModificationTypes.subAction:
              break;
            default:
              opts.push({ text: _.startCase(type), icon: _icon, oc: h_ta, rmt, frt: frameworkRightTypes.dataModification, frv: item, dmt: type })
          }
        })

        opts.push({ text: _.startCase('google'), icon: 'google', oc: h_ta, rmt, frt: frameworkRightTypes.google, dmt: frameworkRightTypes.google })
        opts.push({ text: _.startCase('dataConstraints'), icon: 'shield', oc: h_ta, rmt, frt: frameworkRightTypes.dataConstraints, dmt: frameworkRightTypes.dataConstraints, iconCorner: frAllows.constraints ? 'check' : null, color: frAllows.constraints ? 'green' : null })
        opts.unshift({
          icon: 'content', text: 'Data Options', color: cacheData ? 'green' : 'blue', dividerBefore: true, headerBefore: true,
        })
        if (appUserCollections && _.includes(appUserCollections, view) && itemData) {
          opts.push({ text: _.startCase(view), icon: 'user', oc: h_ta, rmt, frt: frameworkRightTypes.appUserProfile, dmt: frameworkRightTypes.appUserProfile })
        }
      }
    }

  }

  return opts
}

const ammendOpts = (opts, dataMods, h_ta, rmt) => {
  const _opts = []
  _.forEach(dataMods, (_dm, dmKey) => {
    const _icon = settingsIconTypes[dmKey]
    switch (dmKey) {
      case dataModificationTypes.add:
      case dataModificationTypes.edit:
        _opts.unshift({ text: _.startCase(dmKey), icon: _icon, oc: h_ta, rmt, frt: frameworkRightTypes.dataModification, dmt: dmKey })
        break;
      case dataModificationTypes.subAction:
        break;
      default:
        _opts.push({ text: _.startCase(dmKey), icon: _icon, oc: h_ta, rmt, frt: frameworkRightTypes.dataModification, dmt: dmKey })
    }
  })
  if (_opts[0]) {
    _opts[0].dividerBefore = true
  }
  opts.push(..._opts);
}

const options_subActions = (handlers, settings, forTest) => {

  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { dataModification } = settings ?? {}

  const rmt = rightMenuTriggerTypes.frameworkRight

  const opts = []

  if (dataModification && _useDataModification) {
    _.forEach(dataModification, (dm, dmKey) => {
      const _icon = settingsIconTypes[dmKey]
      switch (dmKey) {
        case dataModificationTypes.subAction:
          const { subActionTypes } = dm ?? {}
          if (subActionTypes) {
            _.forEach(subActionTypes, (subActionType) => {
              opts.push({ text: _.startCase(subActionType), icon: _icon, oc: h_ta, rmt, frt: frameworkRightTypes.dataModification, dmt: subActionType, showCaption: true })
            })
          }
          break;
        default:
      }
    })
  }
  !forTest && opts.unshift(...closers(getOptions(hs_cmt).subAction, hs_cmt))
  return opts
}

// overridesChanged
const options_propz = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { overridesChanged } = settings ?? {}
  const opts = []
  opts.push({ text: 'Save', showCaption: true, icon: 'save', color: 'green', disabled: !overridesChanged, oc: h_ta, rmt: rightMenuTriggerTypes.propsSave, frt: frameworkRightTypes.props, })
  // opts.unshift(...closers('Props Override', hs_cmt))
  opts.unshift(...closers(getOptions(hs_cmt).propOverride, hs_cmt))
  return opts
}

const closers = (options, hs_cmt) => {
  const { text } = options ?? {}
  const opts = []
  opts.push({ text: text, icon: appIconTypes.delete, oc: hs_cmt, color: 'red', showCaption: true })
  return opts
}